/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins
 * @LastEditTime: 2021-10-25 19:11:02
 * 每个海报主题通用的基本事件都在这里，拖拽|添加图片|上移|下移|是否显示图片|修改图片名字|裁切等等传递事件逻辑
 * 主题中触发更新 sourceData themeItemData 数据
 * 定义画板
 */

// 定义移动事件的方法
import dataPoster_touch_workstation_data_mixin from '@mixins/dataPoster_touch_workstation_data'

// 每个可被移动的图片单体
import DraggableImageItem from '@components/dataPoster/html/components/draggableImageItem.vue'
export default {
  mixins: [dataPoster_touch_workstation_data_mixin],
  components: { DraggableImageItem },
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    sourceData: {
      type: Object,
      default: () => ({
        posterBgImageUrlBase64: '',
        posterLImageUrlBase64: '',
        type: '', // 7种['', 'init', 'changePic(更换图片)', 'changePicSize(切换图片尺寸)', 'changePicScale(调整缩放比例值)','changeFromChild(子组件触发的修改父级数据)', 'addImage(添加图片)']
        list: [],
      }),
    },
    // updateBaseSourceData: {
    //   type: Function,
    //   default: null,
    // },
    themeItemData: {
      type: Object,
      default: () => ({
        renderData: {},
      }),
    },
    cssDynamicObj: {
      // 有些组件还是需要该字段
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    currPicSize: {
      type: Array,
      default: () => {
        return []
      },
    },
    sizeClassName: {
      // 每个主题配置中都会设置自定义的主题className
      type: Array,
      default: () => {
        return []
      },
    },
    isEditFlag: {
      // 个别主题需要的字段，比如：posterIds: [7, 8, 9]（文本输入框主题）
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileData: {
        fileList: [],
      },
      renderList: null,
    }
  },
  watch: {
    sourceData: {
      handler(newVal, oldVal) {
        console.debug('sourceData:', newVal, oldVal)
        if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          // 同一个主题，只是更换素材触发变化；因为同一个主题，不会变化 fileData 的个数和位置，因此可以这匹配更换 url
          console.debug('sourceData change', newVal, this.curPicItem)

          if (this.curPicItem && newVal.fileList) {
            newVal.fileList.forEach((fileItem) => {
              if (fileItem.uid === this.curPicItem.uid) {
                this.curPicItem = JSON.parse(JSON.stringify(fileItem))
              }
            })
          }
          this.fileData = this.updateBaseSourceData
            ? this.updateBaseSourceData(
                JSON.parse(JSON.stringify(newVal)),
                this.fileData
              )
            : null
          if (['changePicSize', 'moveUp', 'moveDown'].includes(newVal.type)) {
            this.curPicItem = null
          }
        }
      },
      immediate: false,
      deep: true,
    },
    themeItemData: {
      handler(newVal, oldVal) {
        if (newVal && newVal.renderData) {
          // 海报中渲染dom数据
          console.debug(
            'workspace_theme themeItemData:',
            newVal,
            newVal.renderData
          )
          // 每个主题中自定义组装数据逻辑
          this.renderList = this.makePosterIdDatas(
            this.sourceData.posterId,
            newVal.renderData
          )
          console.debug('this.renderList:', this.renderList)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.fileData = JSON.parse(JSON.stringify(this.sourceData))
    // 定义画板的dom，定义完之后才可以开启移动
    this.draggableGroupRefsName = 'workspace_theme'
  },
  methods: {
    updateBaseSourceData(newFileData, oldDileData, callbackArr) {
      // 更新主题中的 sourceData 数据
      // callbackArr: 回调函数数组，暂时还没有主题用到
      console.debug(
        'childComBase_updateBaseSourceData:',
        newFileData,
        oldDileData
      )
      if (
        ['changePicSize', 'addIamge', 'moveUp', 'moveDown'].includes(
          newFileData.type
        )
      ) {
        // 更换尺寸，采用新的 fileData
        return newFileData
      } else {
        const fileList = oldDileData.fileList.map((fileItem, fileIndex) => {
          fileItem.url = newFileData.fileList[fileIndex].url
          fileItem.urlBase64 = newFileData.fileList[fileIndex].urlBase64
          fileItem.isShowPic = newFileData.fileList[fileIndex].isShowPic
          if (newFileData.type === 'init') {
            // 【主题初始化|下载图片|取消选图】时，清空画布上面没用的样式
            // fileItem.isDraggable = false
            fileItem.actState = ''
            fileItem.picRateH = newFileData.fileList[fileIndex].picRateH
            fileItem.picRateW = newFileData.fileList[fileIndex].picRateW
            fileItem.name = newFileData.fileList[fileIndex].name
          } else {
            fileItem.actState = newFileData.fileList[fileIndex].actState
            fileItem.picHeight = newFileData.fileList[fileIndex].picHeight
            fileItem.picWidth = newFileData.fileList[fileIndex].picWidth
            fileItem.useScale = newFileData.fileList[fileIndex].useScale
            fileItem.picRateH = newFileData.fileList[fileIndex].picRateH
            fileItem.picRateW = newFileData.fileList[fileIndex].picRateW
            fileItem.styleItem = newFileData.fileList[fileIndex].styleItem
            fileItem.name = newFileData.fileList[fileIndex].name
          }
          return fileItem
        })
        newFileData.fileList = fileList
        return newFileData
      }
    },
    draggableEventDetailHandler(fileData, event, state, styleItem, curPicItem) {
      // 可以功能抽离的函数-拖拽事件细节处理
      // state：目前只有click，没有其他值
      let classNameArr = []
      // let flag = false
      if (event) {
        // click 都会传 event 事件
        let touchTarget = event.target
        // 使用closest方法查找最近的匹配的父级元素
        const parentElement = touchTarget.closest('.picContainer')
        if (parentElement) {
          classNameArr = parentElement.className.split(' ')
        }
      }

      console.debug(
        'draggableToPicItemChangeEvent start:',
        event,
        state,
        classNameArr,
        curPicItem,
        fileData.fileList
      )

      fileData.fileList.forEach((fileItem) => {
        if (
          event &&
          classNameArr.length > 0 &&
          classNameArr.includes(fileItem.className)
        ) {
          // 当鼠标在其他可移动图片|自身上时会走这里
          fileItem.actState = state
          curPicItem = JSON.parse(JSON.stringify(fileItem))
        } else {
          // 当鼠标经过其他层级dom时
          if (curPicItem && curPicItem.uid === fileItem.uid) {
            if (styleItem) {
              fileItem.styleItem = styleItem
              curPicItem = JSON.parse(JSON.stringify(fileItem))
            }
            fileItem.actState = state
          }
        }
      })
      return {
        fileData,
        curPicItem,
      }
    },
    draggableToPicItemChangeEvent(event, state, styleItem) {
      // 正常流程是：点击可以直接拖拽走，拖拽时和结束后一直保留选中样式

      const dataObj = this.draggableEventDetailHandler(
        this.fileData,
        event,
        state,
        styleItem,
        this.curPicItem
      )
      this.fileData = dataObj.fileData
      this.curPicItem = dataObj.curPicItem

      console.debug(
        'draggableToPicItemChangeEvent brefore:',
        state,
        this.curPicItem,
        this.fileData
      )
      if (this.curPicItem) {
        this.$emit('curPicItemEvent', {
          data: this.curPicItem,
        })
      }
    },
    _valFormatHandler(val, defaultVal, ceil) {
      // 格式化数据val值,可以自定义默认值 defaultVal 和单位 ceil，现在默认的值是'-'
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = defaultVal ? defaultVal : ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      return data
    },
  },
}
